module.exports = __webpack_public_path__ + "static/img/star-off.d88db0fb.png";